function r(t) {
  return typeof t == "object" && t !== null && (Object.getPrototypeOf(t) === Object.prototype || Object.getPrototypeOf(t) === null) && !Array.isArray(t) && !t.$$typeof;
}
const e = (t, o) => {
  try {
    t.scrollIntoViewIfNeeded(o);
  } catch {
    t.scrollIntoView(o);
  }
};
export {
  r as isPureObject,
  e as scrollIntoView
};
